import { useState, useEffect, useId } from "react";
import { Form } from "react-bootstrap";
import { processAuctionDate } from "../utils";

/**
 * Displays the sale time in either the sale's local timezone or the user's
 * local timezone, with a checkbox to toggle between the two.
 *
 * Uses useId() so each card gets a unique control id. propIndex alone was
 * reused across sale groups (0–8 per group), causing duplicate ids and WAVE
 * "Multiple form labels" when navigating from the auction list with
 * timeFrame=All Future Sale Dates.
 */
const TimeToggle = ({ property }) => {
  const toggleId = useId().replace(/:/g, "");

  const [saleLocalTime, setSaleLocalTime] = useState("N/A");
  const [userLocalTime, setUserLocalTime] = useState("N/A");
  const [showSaleTime, setShowSaleTime] = useState(true);

  useEffect(() => {
    if (!property.auctionDate || !property.state || !property.county) return;

    const actualTime = property?.auctionDetail?.time || property.time || "";
    if (!actualTime) {
      setSaleLocalTime("");
      setUserLocalTime("");
      return;
    }

    const [timePart, meridian] = actualTime.split(" ");
    if (!timePart || !meridian) return;

    let [hours, minutes] = timePart.split(":");
    hours = parseInt(hours, 10);
    minutes = parseInt(minutes, 10) || 0;

    if (meridian.toUpperCase() === "PM" && hours !== 12) hours += 12;
    else if (meridian.toUpperCase() === "AM" && hours === 12) hours = 0;

    const [month, day, year] = property.auctionDate.split("/");
    const isoDateTime = `${year}-${month}-${day}T${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:00`;

    const { saleLocalTime: sLocal, userLocalTime: uLocal } = processAuctionDate(
      isoDateTime,
      property.state,
      property.county
    );

    setSaleLocalTime(sLocal.includes(",") ? sLocal.split(",")[1].trim() : sLocal);
    setUserLocalTime(uLocal.includes(",") ? uLocal.split(",")[1].trim() : uLocal);
  }, [property.auctionDate, property.state, property.county, property.auctionDetail, property.time]);

  return (
    <>
      <div className="card-text-row">
        <span className="card-text-label">Sale Time:</span>
        <span className="card-text-value truncate">{showSaleTime ? saleLocalTime : userLocalTime}</span>
      </div>
      <Form.Check
        type="checkbox"
        id={toggleId}
        className="property-card-time-switch mb-3 mt-1"
        label={`Show ${showSaleTime ? "User's Local Time" : "Sale's Local Time"}`}
        checked={showSaleTime}
        onChange={() => setShowSaleTime((prev) => !prev)}
      />
    </>
  );
};

export default TimeToggle;
